const menuButton = document.querySelector('.menu-button');
const mobileNav = document.querySelector('.mobile-nav');

menuButton?.addEventListener('click', () => {
  const open = mobileNav.classList.toggle('is-open');
  menuButton.setAttribute('aria-expanded', String(open));
  menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
});

mobileNav?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
  mobileNav.classList.remove('is-open');
  menuButton.setAttribute('aria-expanded', 'false');
  menuButton.setAttribute('aria-label', 'Open menu');
}));

const gallery = document.querySelector('[data-rotating-gallery]');
if (gallery) {
  const slides = [...gallery.querySelectorAll('.hero-slide')];
  const dots = [...gallery.querySelectorAll('.hero-slide-dot')];
  const toggle = gallery.querySelector('.hero-rotation-toggle');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let active = 0;
  let paused = false;
  let timer;

  const showSlide = index => {
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, position) => {
      const selected = position === active;
      slide.classList.toggle('is-active', selected);
      slide.setAttribute('aria-hidden', String(!selected));
      dots[position].classList.toggle('is-active', selected);
      dots[position].setAttribute('aria-pressed', String(selected));
    });
  };

  const schedule = () => {
    window.clearTimeout(timer);
    if (paused || reducedMotion.matches || document.hidden) return;
    timer = window.setTimeout(() => {
      showSlide(active + 1);
      schedule();
    }, 7000);
  };

  dots.forEach((dot, index) => dot.addEventListener('click', () => {
    showSlide(index);
    schedule();
  }));

  toggle.addEventListener('click', () => {
    paused = !paused;
    toggle.setAttribute('aria-label', paused ? 'Play image rotation' : 'Pause image rotation');
    toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
    schedule();
  });

  document.addEventListener('visibilitychange', schedule);
  reducedMotion.addEventListener?.('change', schedule);
  schedule();
}

if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
  const selectors = '.intro-grid,.services-head,.service-card,.approach-copy-inner,.about-grid,.visit-grid,.page-intro,.section-title,.step,.split-feature,.contact-card,.treatment-list > *,.faq-list,.page-footer-cta .wrap,.instagram-head,.instagram-photo';
  const elements = [...document.querySelectorAll(selectors)];
  elements.forEach((el, index) => {
    el.classList.add('motion-reveal');
    if (el.classList.contains('service-card') || el.classList.contains('step') || el.classList.contains('instagram-photo')) {
      el.style.transitionDelay = `${Math.min(index % 3, 2) * 85}ms`;
    }
  });
  document.documentElement.classList.add('motion-ready');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -25px 0px' });
  elements.forEach(el => observer.observe(el));
}
